import { AppNavigationBrands, NavigationBrands } from '../../constants'

// Route Flows
import LinkAccountRoutes from './linkAccount'
import LoanRoutes from './loans'
import TrustedDeviceRoutes from './trustedDevice'
import UpdateUserRoutes from './updateUser'

// Route Pages
const AccountSelect = () => import('../../components/loans/pages/common/AccountSelect.vue')
const CompleteProfile = () => import('../../components/referral/pages/CompleteProfile.vue')
const ExternalBrowserAuth = () => import('../../components/common/pages/ExternalBrowserAuth.vue')
const InvictusCustomerProfile = () => import('../../components/loans/pages/invictus/InvictusCustomerProfile.vue')
const InvictusSecurityQuestion = () => import('../../components/loans/pages/invictus/InvictusSecurityQuestion.vue')
const Landing = () => import('../../components/common/pages/Landing.vue')
const RedeemAddCard = () => import('../../components/referral/pages/RedeemAddCard.vue')
const RedeemReview = () => import('../../components/referral/pages/RedeemReview.vue')
const RedeemSuccess = () => import('../../components/referral/pages/RedeemSuccess.vue')
const ReferralRewards = () => import('../../components/referral/pages/ReferralRewards.vue')

// Route Parents
const GenericParent = () => import('../../components/common/pages/GenericParent.vue')
const ReferralParent = () => import('../../components/common/pages/ReferralParent.vue')

const appBrand = AppNavigationBrands[process.env.VUE_APP_AppBrand]

export default () => {
  const routes = [
    {
      path: 'Home',
      name: 'Home',
      component: Landing,
      props: true
    },
    {
      path: 'InvictusCustomerProfile',
      name: 'InvictusCustomerProfile',
      component: InvictusCustomerProfile,
      props: true
    },
    {
      path: 'InvictusSecurityQuestion',
      name: 'InvictusSecurityQuestion',
      component: InvictusSecurityQuestion,
      props: true
    },
    {
      path: 'ExternalBrowserAuth/:name',
      name: 'ExternalBrowserAuth',
      component: ExternalBrowserAuth,
      meta: { flow: 'ExternalBrowser' },
      props: true
    },
    {
      path: 'LinkAccountOptions',
      component: GenericParent,
      props: true,
      meta: { flow: 'LinkAccount' },
      children: LinkAccountRoutes()
    },
    {
      path: 'TrustedDevice',
      component: GenericParent,
      meta: {
        flow: 'TrustedDevice'
      },
      props: true,
      children: TrustedDeviceRoutes()
    },
    {
      path: 'UpdateUser',
      component: GenericParent,
      meta: {
        flow: 'UpdateUser'
      },
      props: true,
      children: UpdateUserRoutes()
    },
    {
      path: 'AccountSelect',
      name: 'AccountSelect',
      component: AccountSelect,
      props: true
    },
    {
      path: 'Referral',
      component: ReferralParent,
      props: true,
      meta: { flow: 'Referral' },
      children: [
        {
          path: '',
          name: 'ReferralRewardsHome',
          component: ReferralRewards,
          props: true
        },
        {
          path: 'ReferCompleteProfile',
          name: 'ReferCompleteProfile',
          component: CompleteProfile,
          props: true
        },
        {
          path: 'ReferRedeemAddCard',
          name: 'ReferRedeemAddCard',
          component: RedeemAddCard,
          props: true
        },
        {
          path: 'ReferRedeemReview',
          name: 'ReferRedeemReview',
          component: RedeemReview,
          props: true
        },
        {
          path: 'ReferRedeemSuccess',
          name: 'ReferRedeemSuccess',
          component: RedeemSuccess,
          props: true
        }
      ]
    }
  ]

  // Add route brands for TMX and INL if either matches the appBrand
  if (appBrand === NavigationBrands.TitleMax || appBrand === NavigationBrands.InstaLoan) {
    routes.push({
      path: NavigationBrands.TitleMax,
      component: GenericParent,
      props: true,
      meta: {
        flow: 'Loans',
        brand: NavigationBrands.TitleMax
      },
      children: LoanRoutes(NavigationBrands.TitleMax)
    })
    routes.push({
      path: NavigationBrands.InstaLoan,
      component: GenericParent,
      props: true,
      meta: {
        flow: 'Loans',
        brand: NavigationBrands.InstaLoan
      },
      children: LoanRoutes(NavigationBrands.InstaLoan)
    })
  } else {
    // Add route brands only for the appBrand
    routes.push({
      path: appBrand,
      component: GenericParent,
      props: true,
      meta: {
        flow: 'Loans',
        brand: appBrand
      },
      children: LoanRoutes(appBrand)
    })
  }
  return routes
}
